import { c as _c } from "react/compiler-runtime";
import { IconTriangleCaution } from '@endurancewarranty/icons';
import { Button, Flex, Text } from '@endurancewarranty/ui';
import { useAppRouter } from '@hooks/navigation';
import { AppRouteEnum } from '@lib/enums';
import { ParameterTypeEnum } from '@lib/enums/ParameterTypeEnum';
import type { FC } from 'react';
export type Props = {
  onClose: () => void;
  params: Record<number, string>;
};
export const ClosedQuoteErrorModal: FC<Props> = t0 => {
  const $ = _c(6);
  const {
    onClose,
    params
  } = t0;
  const router = useAppRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Flex justify="center"><Flex className="h-14 w-14 rounded-full bg-red-100" items="center" justify="center"><IconTriangleCaution className="text-red-600" width={32} /></Flex></Flex>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4"><Text.Body size="lg" fontWeight="bold" align="center">Quote is closed</Text.Body><Text.Body align="center" margin="mt-1">This quote is closed and can no longer be updated. Please create a new quote for this vehicle.</Text.Body></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose || $[3] !== params || $[4] !== router) {
    t3 = <Flex direction="col" className="h-42" justify="between">{t1}{t2}<Flex justify="end" className="mt-4"><Button name="create-new-quote" variant="primary" width="fit" onClick={() => {
          onClose();
          router.build(AppRouteEnum.QuoteFlowClosed).setId(params[ParameterTypeEnum.QuoteId]).go();
        }}>Create a new quote</Button></Flex></Flex>;
    $[2] = onClose;
    $[3] = params;
    $[4] = router;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};